module.exports = alphaShape

var ac = require('alpha-complex')
var bnd = require('simplicial-complex-boundary')

function alphaShape(alpha, points) {
  return bnd(ac(alpha, points))
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/alpha-shape/alpha.js
// module id = zhiv
// module chunks = 0